import { render, staticRenderFns } from "./mask.vue?vue&type=template&id=24ea1f2d"
import script from "./mask.vue?vue&type=script&lang=js"
export * from "./mask.vue?vue&type=script&lang=js"
import style0 from "./mask.vue?vue&type=style&index=0&id=24ea1f2d&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports